import React from 'react';
import StandardLayout from '../components/common/StandardLayout';
import PageHeader from '../components/common/PageHeader';
import Button from '../components/ui/Button';
import { Building2, Home, Settings, RefreshCw, Plus } from 'lucide-react';
import BrokerAccountsList from '../components/broker/BrokerAccountsList';

const BrokersPage: React.FC = () => {
  const actions = (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        onClick={() => window.dispatchEvent(new CustomEvent('brokerRefresh'))}
        leftIcon={<RefreshCw className="h-4 w-4" />}
        size="sm"
      >
        Refresh
      </Button>
      <Button
        onClick={() => window.dispatchEvent(new CustomEvent('brokerAdd'))}
        leftIcon={<Plus className="h-4 w-4" />}
        size="sm"
      >
        Add Broker
      </Button>
    </div>
  );

  return (
    <StandardLayout>
      <PageHeader
        title="Broker Accounts"
        pageType="management"
        icon={<Building2 className="w-5 h-5" />}
        breadcrumbs={[
          { label: 'Home', href: '/', icon: <Home className="w-4 h-4" /> },
          { label: 'Broker Management', icon: <Settings className="w-4 h-4" /> }
        ]}
        actions={actions}
      />
      <BrokerAccountsList />
    </StandardLayout>
  );
};

export default BrokersPage;
